import Notify from 'simple-notify'
import shave from "shave";
import Inputmask from "inputmask";
import LazyLoad from "vanilla-lazyload";

export const findParent = (el, className) => {
    let _this = el;

    while (_this && !_this.classList.contains(className)) {
        _this = _this.parentNode;

        if (_this === document.body) {
            _this = null;
        }
    }

    return _this;
}

export function formatNumber(number, n, x, s, c) {
    var re = '\\d(?=(\\d{' + (x || 3) + '})+' + (n > 0 ? '\\D' : '$') + ')',
        num = Number((number)).toFixed(Math.max(0, ~~n)).toLocaleString();

    return (c ? num.replace('.', c) : num).replace(new RegExp(re, 'g'), '$&' + (s || ','));
}

window._isMobile = (thisWidth) => {
    let _laptopXs = '769';

    if (thisWidth !== '') {
        _laptopXs = thisWidth;
    }

    let _width = window.innerWidth
        || document.documentElement.clientWidth
        || document.body.clientWidth;

    let _isMobileAttr = false;
    if (_width <= _laptopXs) {
        _isMobileAttr = true;
    }

    return _isMobileAttr;
}

function validEmail(email) {
    var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(email);
}

shave('.js-shave-28', 28);
shave('.js-shave-11', 11);
shave('.js-shave-12', 12);
shave('.js-shave-13', 15);


//function resetHeight(){
//    document.body.style.height = window.innerHeight + "px";
//}

//window.addEventListener("resize", resetHeight);
//window.addEventListener("load", resetHeight);

window.setInputParentStatus = (inputParent, status) => {
    if (inputParent) {
        if (inputParent.classList.contains('success')) {
            inputParent.classList.remove('success')
        }

        if (inputParent.classList.contains('error')) {
            inputParent.classList.remove('error')
        }

        if (status !== '') {
            if (!inputParent.classList.contains(status)) {
                inputParent.classList.add(status)
            }
        }
    }
}

window.setInputFloatingLabel = (inputParent, text) => {
    if (inputParent) {
        let floatingLabel = inputParent.querySelector('span.floating-label')
        if(floatingLabel) {
            if (text === '') {
                text = floatingLabel.dataset.label
            }
            floatingLabel.innerHTML = text
        }
    }
}

window.closeAllModals = () => {
    let modals = document.querySelectorAll('.modal-custom')
    modals.forEach((modal) => {
        modal.classList.remove('modal-opened')
    })

    document.querySelector('body').classList.remove('no-scroll');
}

window.closeSheet = () => {
    let sheet = document.querySelector('.sheet-column')
    document.body.classList.remove("sheet-opened");
    sheet.setAttribute("aria-hidden", true)
}

window.checkEmptyInputs = (inputs) => {
    let oneInput
    let oneCheckbox
    let isValid = true

    for (let i = 0; i < inputs.length; ++i) {
        let input = inputs[i];
        oneInput = input.querySelector('input[type="text"], input[type="password"]')
        if (oneInput) {
            if (oneInput.value === '') {
                isValid = false
                input.classList.add('error')
            }
        }

        oneCheckbox = input.querySelector('input[type="checkbox"]')
        if (oneCheckbox) {
            if (oneCheckbox.checked !== true) {
                isValid = false
                input.classList.add('error')

                oneCheckbox.addEventListener("change", (e) => {
                    input.classList.remove('error');
                })
            }
        }
    }

    return isValid
}

window.showModal = (templateId) => {
    let template = document.getElementById(templateId);
    if (!template) {
        return false
    }

    template.classList.add('modal-opened')
}

window.declOfNum = (n, titles) => {
    return titles[(n % 10 === 1 && n % 100 !== 11) ? 0 : n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2]
}

window.getOffset = (el, cont, data) => {
    const elementRect = el.getBoundingClientRect();
    const containerRect = cont.getBoundingClientRect();
    const dataReact = data.getBoundingClientRect();

    return {
        elementX: elementRect.left - containerRect.left,
        elementY: elementRect.top - containerRect.top,
        dataX: dataReact.left - containerRect.left,
        dataY: dataReact.top - containerRect.top,
    };
}

window.fallbackCopyTextToClipboard = function (text) {
    var textArea = document.createElement("textarea");
    textArea.value = text;

    // Avoid scrolling to bottom
    textArea.style.top = "0";
    textArea.style.left = "0";
    textArea.style.position = "fixed";

    document.body.appendChild(textArea);
    textArea.focus();
    textArea.select();

    try {
        var successful = document.execCommand('copy');
        var msg = successful ? 'successful' : 'unsuccessful';
    } catch (err) {}

    document.body.removeChild(textArea);

    return msg;
}

window.copyTextToClipboard = function (text) {
    if (!navigator.clipboard) {
        return window.fallbackCopyTextToClipboard(text);
    }
    navigator.clipboard.writeText(text).then(function() {
    }, function(err) {});
}

function showCallWaiterInRotation() {
    const targets = document.getElementsByClassName('call-waiter--target');
    let currentIndex = -1;
    for (let i = 0; i < targets.length; i++) {
        if (targets[i].classList.contains('show')) {
            currentIndex = i;
            break;
        }
    }

    if (currentIndex >= 0) {
        targets[currentIndex].classList.remove('show');
    }

    const nextIndex = (currentIndex + 1) % targets.length;

    targets[nextIndex].classList.add('show');
}

if (document.location.pathname.indexOf("--register-error") >= 1) {
    let input = document.querySelector('input[name="name"]')
    if (input) {
        input.setAttribute('value',  "test name")
        input.dispatchEvent(new Event('change', { 'bubbles': true }))

        setInputFloatingLabel(input.closest('.base-input-wrp'), 'Имя пользователя уже занято')
        setInputParentStatus(input.closest('.base-input-wrp'), 'error')
    }
}

if (document.location.pathname.indexOf("--edit-user-name-error") >= 1) {
    let input = document.querySelector('input[name="name"]')
    if (input) {
        input.setAttribute('value',  "test name")
        input.dispatchEvent(new Event('change', { 'bubbles': true }))

        setInputFloatingLabel(input.closest('.base-input-wrp'), 'Имя пользователя уже занято')
        setInputParentStatus(input.closest('.base-input-wrp'), 'error')
    }
}

if (document.location.pathname.indexOf("user-profile-delete--error") >= 1) {
    let input = document.querySelector('input[name="phone"]')
    if (input) {
        input.setAttribute('value',  "77777777777")
        input.dispatchEvent(new Event('change', { 'bubbles': true }))

        setInputFloatingLabel(input.closest('.base-input-wrp'), 'Этот номер привязан к другому аккаунту')
        setInputParentStatus(input.closest('.base-input-wrp'), 'error')
    }
}

if (document.location.pathname.indexOf("--modal-order-choose") >= 1) {
    window.showModal('modal-desktop-menu-add-order')
}

if (document.location.pathname.indexOf("--not-visited-modal") >= 1) {
    window.showModal('modal-visit-establishment')
}

if (document.location.pathname.indexOf("coupon--activated") >= 1) {
    window.showModal('modal-coupon-success')
}

if (document.location.pathname.indexOf("--modal-quest-cancle-success") >= 1) {
    window.showModal('modal-quest-cancle-success')
}

if (document.location.pathname.indexOf("preview-new--not-active-flytime") >= 1) {
    window.showModal('modal-privilage-activate-flytime')
}

if (document.location.pathname.indexOf("modal-quest-limited") >= 1) {
    window.showModal('modal-quest-limited')
}

if (document.location.pathname.indexOf("--modal-quest-inactive-limited") >= 1) {
    window.showModal('modal-quest-limited-inactive')
}

if (document.location.pathname.indexOf("--modal-deleted-user-dialog") >= 1) {
    window.showModal('modal-deleted-user-dialog-success')
}

if (document.location.pathname.indexOf("--modal-gallery-photo-archive") >= 1) {
    window.showModal('modal-user-gallery-photo-archive-success')
}

if (document.location.pathname.indexOf("--modal-pincode-setted") >= 1) {
    window.showModal('modal-pincode-setted')
}

if (document.location.pathname.indexOf("--modal-added-gallery") >= 1) {
    window.showModal('modal-gallery-added-success')
}

if (document.location.pathname.indexOf("--modal-added-moments") >= 1) {
    window.showModal('modal-moments-added-success')
}

if (document.location.pathname.indexOf("--modal-phone-edited-success") >= 1) {
    window.showModal('modal-phone-edited-success')
}

if (document.location.pathname.indexOf("--modal-bdate-updated-success") >= 1) {
    window.showModal('modal-bdate-updated-success')
}

if (document.location.pathname.indexOf("--modal-bdate-update-limit") >= 1) {
    window.showModal('modal-bdate-update-limit')
}

if (document.location.pathname.indexOf("--modal-gift-sended-success") >= 1) {
    window.showModal('modal-gift-sended-success')
}

if (document.location.pathname.indexOf("--modal-image-sended-delete-success") >= 1) {
    window.showModal('modal-image-sended-delete-success')
}


if (document.location.pathname.indexOf("--loader") >= 1) {
    window.showModal('loader')
}


if (document.location.pathname.indexOf("---notify-one-visit") >= 1) {
    let myNotify = new Notify({
        status: 'info',
        title: '',
        text: '<a href="privileges--preview-involved.html">Засчитано одно посещение в квесте!<br/>Кликните чтобы узнать больше</a>',
        effect: 'fade',
        speed: 300,
        customClass: 'custom-quest-notify',
        customIcon: '<span class="icon--pin-line"></span>',
        showIcon: true,
        showCloseButton: true,
        autoclose: false,
        autotimeout: 3000,
        gap: 20,
        distance: 0,
        type: 1,
        position: 'center top'
    })
}

if (document.location.pathname.indexOf("---notify-present") >= 1) {
    let myNotify = new Notify({
        status: 'info',
        title: '',
        text: '<a href="privileges--result-poll.html">Вам отправили подарок! <br/> Кликните чтобы узнать больше</a>',
        effect: 'fade',
        speed: 300,
        customClass: 'custom-present-notify',
        customIcon: '<span class="icon-notify--gift"></span>',
        showIcon: true,
        showCloseButton: true,
        autoclose: false,
        autotimeout: 3000,
        gap: 20,
        distance: 0,
        type: 1,
        position: 'center top'
    })
}

(function() {
    var lazyLoadInstance = new LazyLoad({});

    let maskInputs = document.querySelectorAll('[data-mask]');
    if (maskInputs) {
        Array.from(maskInputs).forEach(function(element, index, array){
            if (element.dataset.mask) {
                Inputmask({
                    "clearMaskOnLostFocus": true,
                    "clearIncomplete": true,
                    "mask": element.dataset.mask
                }).mask(element);
            }
        });
    }

    let divCallWaiter = document.querySelectorAll('.call-waiter--target');
    if (divCallWaiter) {
        setInterval(showCallWaiterInRotation, 10000);
    }

    Array.from(document.querySelectorAll('[contenteditable="true"]')).forEach(function(element, index, array){
        element.addEventListener('input', function(event){
            if (element.dataset.id && document.getElementById(element.dataset.id)) {
                document.getElementById(element.dataset.id).value = event.target.innerText;
            }
        })
    })

    let copyClipboards = document.querySelectorAll('.copy-input')
    if (copyClipboards && copyClipboards.length > 0) {
        copyClipboards.forEach((el) => {
            el.addEventListener("click", function (e) {
                e.preventDefault();

                let inputTextId = el.dataset.target;
                let element = document.getElementById(inputTextId)
                if (element && element.textContent) {
                    window.copyTextToClipboard(element.textContent);
                }
            });
        })
    }

    let openHiddens = document.querySelectorAll('.open-hidden')
    if (openHiddens && openHiddens.length > 0) {
        let elShowHide
        let targetId
        let showHide
        let element
        openHiddens.forEach((el) => {
            el.addEventListener("click", function (e) {
                e.preventDefault();

                showHide = el.dataset.hideshow;
                targetId = el.dataset.target;
                element = document.getElementById(targetId)
                if (element) {
                    element.classList.toggle("visible");
                    el.classList.toggle("opened");
                    if (showHide) {
                        elShowHide = document.getElementById(showHide)
                        elShowHide.classList.toggle("hidden");
                    }
                }
            });
        })
    }
})();